// ECDEV-176: [Flags] enum mirroring the backend DocumentApprovalRole.
// Combine Customer (1) + CmInventory (2) => 3 for "both required".
export enum DocumentApprovalRole {
  None = 0,
  Customer = 1,
  CmInventory = 2,
}

export const DOCUMENT_APPROVAL_ROLE_OPTIONS = [
  { label: 'No approval', value: DocumentApprovalRole.None },
  { label: 'Customer', value: DocumentApprovalRole.Customer },
  { label: 'CM Inventory', value: DocumentApprovalRole.CmInventory },
  {
    label: 'Customer + CM Inventory',
    value: DocumentApprovalRole.Customer | DocumentApprovalRole.CmInventory,
  },
];

export function approvalRoleLabel(role: number | null | undefined): string {
  const value = role ?? DocumentApprovalRole.None;
  const match = DOCUMENT_APPROVAL_ROLE_OPTIONS.find((o) => o.value === value);
  return match ? match.label : 'No approval';
}

export function requiresCustomer(role: number | null | undefined): boolean {
  return ((role ?? 0) & DocumentApprovalRole.Customer) !== 0;
}

export function requiresCmInventory(role: number | null | undefined): boolean {
  return ((role ?? 0) & DocumentApprovalRole.CmInventory) !== 0;
}

// ECDEV-412: what a CM Admin can approve or reject on behalf of, given the slots still pending
// on a document. The arrays are constants so a template binding keeps a stable identity.
const ON_BEHALF_CUSTOMER = { label: 'Customer', value: DocumentApprovalRole.Customer };
const ON_BEHALF_CM_INVENTORY = {
  label: 'CM Inventory',
  value: DocumentApprovalRole.CmInventory,
};
const ON_BEHALF_BOTH = {
  label: 'Customer + CM Inventory',
  value: DocumentApprovalRole.Customer | DocumentApprovalRole.CmInventory,
};

const ON_BEHALF_OPTIONS: Record<number, { label: string; value: DocumentApprovalRole }[]> = {
  [DocumentApprovalRole.None]: [],
  [DocumentApprovalRole.Customer]: [ON_BEHALF_CUSTOMER],
  [DocumentApprovalRole.CmInventory]: [ON_BEHALF_CM_INVENTORY],
  [ON_BEHALF_BOTH.value]: [ON_BEHALF_CUSTOMER, ON_BEHALF_CM_INVENTORY, ON_BEHALF_BOTH],
};

export function onBehalfOptions(pending: number) {
  return ON_BEHALF_OPTIONS[pending] ?? [];
}

// With a single slot pending there is nothing to choose, so it is preselected. With both pending
// the admin has to say whose approval this is.
export function defaultOnBehalfRole(pending: number): DocumentApprovalRole {
  return pending === DocumentApprovalRole.Customer ||
    pending === DocumentApprovalRole.CmInventory
    ? pending
    : DocumentApprovalRole.None;
}
